import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({

   paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
   },
   datePicker: {
      minWidth: "100%",
      marginTop: theme.spacing(2),
   },

}), { index: 1 });